// src/components/Blog.js
import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaChevronRight } from "react-icons/fa";
import { useData } from "../hooks/useData";
import { getPosts } from "../firebase/dataService";
import "./Blog.css";

const formatDate = (ts) => {
  if (!ts) return "";
  try {
    const d = typeof ts.toDate === "function" ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  } catch { return ""; }
};

const SkeletonCard = () => (
  <div className="blog-skeleton">
    <div className="skeleton" style={{ height: "180px" }} />
    <div style={{ padding: "1.25rem", display: "flex", flexDirection: "column", gap: "0.75rem" }}>
      <div className="skeleton" style={{ height: "14px", width: "40%" }} />
      <div className="skeleton" style={{ height: "18px", width: "80%" }} />
      <div className="skeleton" style={{ height: "12px" }} />
    </div>
  </div>
);

const BlogCard = ({ post }) => (
  <article className="blog-card card">
    <Link to={`/blog/${post.slug}`} className="blog-card__img-wrap">
      <img
        src={post.coverImage || `https://picsum.photos/seed/${encodeURIComponent(post.slug || post.id)}/600/360`}
        alt={post.title}
        loading="lazy"
      />
    </Link>
    <div className="blog-card__body">
      <div className="blog-card__meta">
        {post.category && <span className="badge badge-accent">{post.category}</span>}
        <span className="blog-card__date">{formatDate(post.publishedAt || post.createdAt)}</span>
      </div>
      <h3 className="blog-card__title">
        <Link to={`/blog/${post.slug}`}>{post.title}</Link>
      </h3>
      {post.excerpt && <p className="blog-card__excerpt">{post.excerpt}</p>}
      <Link to={`/blog/${post.slug}`} className="btn btn-ghost blog-card__toggle">
        Read more <FaChevronRight size={11} />
      </Link>
    </div>
  </article>
);

const Blog = ({ limit, title = "From the Blog", showAll = false }) => {
  const { data: posts, loading, error } = useData(getPosts);
  const displayed = limit ? posts.slice(0, limit) : posts;

  return (
    <section className="blog-section">
      <div className="container">
        <div className="blog-section__header">
          <div>
            <p className="section-label">Writing</p>
            <h2 className="section-title">{title}</h2>
          </div>
          {showAll && (
            <Link to="/blog" className="btn btn-outline">
              All Posts <FaArrowRight size={13} />
            </Link>
          )}
        </div>

        {error && (
          <p style={{ color: "var(--accent)", textAlign: "center", padding: "2rem" }}>
            Failed to load posts. Please try again.
          </p>
        )}

        {loading ? (
          <div className="blog-grid">
            {Array.from({ length: limit || 3 }).map((_, i) => <SkeletonCard key={i} />)}
          </div>
        ) : displayed.length === 0 ? (
          <p style={{ color: "var(--text-3)", textAlign: "center", padding: "2rem" }}>
            No posts yet — check back soon.
          </p>
        ) : (
          <div className="blog-grid">
            {displayed.map(post => <BlogCard key={post.id} post={post} />)}
          </div>
        )}
      </div>
    </section>
  );
};

export default Blog;
